import { CheckboxStateEnum } from "../../../../../shared/enums/CheckboxSelectionType";
import { DamagePersonalDataModel } from "../../../../../shared/models/view/DamagePersonalData";
import { AppUtils } from '../../../../../shared/utils/index';


/**
 * Model class for the PersonalDataOhcFormModel
 */
export class PersonalDataFormModel extends DamagePersonalDataModel {


	private versicherungKrankenschutzGesellschaft: string;
	private versicherungKrankenschutzVersicherungnummer: string;
	private versicherungReiseschtuz: CheckboxStateEnum;
	private versicherungReiseschutzGesellschaft: string;
	private versicherungReiseschutzVersicherungsnummer: string;
	private versicherungReiseschutzAnschrift: string;
	private versicherungReiseschutzKreditkartengesellschaft: string;
	private versicherungReiseschutzKreditkartennummer: string;
	private versicherungReiseschutzBankname: string;
	private versicherungUnfallschutz: CheckboxStateEnum;
	private versicherungUnfallschutzGesellschaft: string;
	private versicherungUnfallschutzVersicherungsnummer: string;
	private versicherungUnfallschutzAnschrift: string;

	constructor(initialProperties?: Partial<PersonalDataFormModel>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}


	public get VersicherungKrankenschutzGesellschaft(): string {
		return this.versicherungKrankenschutzGesellschaft;
	}
	public set VersicherungKrankenschutzGesellschaft(value: string) {
		this.versicherungKrankenschutzGesellschaft = value;
	}

	public get VersicherungKrankenschutzVersicherungnummer(): string {
		return this.versicherungKrankenschutzVersicherungnummer;
	}
	public set VersicherungKrankenschutzVersicherungnummer(value: string) {
		this.versicherungKrankenschutzVersicherungnummer = value;
	}

	public get VersicherungReiseschtuz(): CheckboxStateEnum {
		return this.versicherungReiseschtuz;
	}
	public set VersicherungReiseschtuz(value: CheckboxStateEnum) {
		this.versicherungReiseschtuz = value;
	}

	public get VersicherungReiseschutzGesellschaft(): string {
		return this.versicherungReiseschutzGesellschaft;
	}
	public set VersicherungReiseschutzGesellschaft(value: string) {
		this.versicherungReiseschutzGesellschaft = value;
	}

	public get VersicherungReiseschutzVersicherungsnummer(): string {
		return this.versicherungReiseschutzVersicherungsnummer;
	}
	public set VersicherungReiseschutzVersicherungsnummer(value: string) {
		this.versicherungReiseschutzVersicherungsnummer = value;
	}

	public get VersicherungReiseschutzAnschrift(): string {
		return this.versicherungReiseschutzAnschrift;
	}
	public set VersicherungReiseschutzAnschrift(value: string) {
		this.versicherungReiseschutzAnschrift = value;
	}

	public get VersicherungReiseschutzKreditkartengesellschaft(): string {
		return this.versicherungReiseschutzKreditkartengesellschaft;
	}
	public set VersicherungReiseschutzKreditkartengesellschaft(value: string) {
		this.versicherungReiseschutzKreditkartengesellschaft = value;
	}

	public get VersicherungReiseschutzKreditkartennummer(): string {
		return this.versicherungReiseschutzKreditkartennummer;
	}
	public set VersicherungReiseschutzKreditkartennummer(value: string) {
		this.versicherungReiseschutzKreditkartennummer = value;
	}

	public get VersicherungReiseschutzBankname(): string {
		return this.versicherungReiseschutzBankname;
	}
	public set VersicherungReiseschutzBankname(value: string) {
		this.versicherungReiseschutzBankname = value;
	}

	public get VersicherungUnfallschutz(): CheckboxStateEnum {
		return this.versicherungUnfallschutz;
	}
	public set VersicherungUnfallschutz(value: CheckboxStateEnum) {
		this.versicherungUnfallschutz = value;
	}

	public get VersicherungUnfallschutzGesellschaft(): string {
		return this.versicherungUnfallschutzGesellschaft;
	}
	public set VersicherungUnfallschutzGesellschaft(value: string) {
		this.versicherungUnfallschutzGesellschaft = value;
	}

	public get VersicherungUnfallschutzVersicherungsnummer(): string {
		return this.versicherungUnfallschutzVersicherungsnummer;
	}
	public set VersicherungUnfallschutzVersicherungsnummer(value: string) {
		this.versicherungUnfallschutzVersicherungsnummer = value;
	}

	public get VersicherungUnfallschutzAnschrift(): string {
		return this.versicherungUnfallschutzAnschrift;
	}
	public set VersicherungUnfallschutzAnschrift(value: string) {
		this.versicherungUnfallschutzAnschrift = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PersonalDataFormModel {
		return new PersonalDataFormModel(DamagePersonalDataModel.createFromObject(dataObject));
	}
}